import { Avatar, Image } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { masterFiltersSelector, userIdSelector } from '../../../selectors';
import { EMasterTabs } from '../../../types/masterFilters';
import { IUserInChatListSchema } from '../../../types/userData';

type TUsePreviewAvatar = {
  users: IUserInChatListSchema[];
};

export const usePreviewAvatarNode = ({ users }: TUsePreviewAvatar): React.ReactNode | null => {
  const userId = useSelector(userIdSelector);
  const { activeTab } = useSelector(masterFiltersSelector);

  const opponent = users.find(user => user.chatRole === 'opponent');
  const masterUser = users.find(user => user.chatRole === 'master');

  return React.useMemo(() => {
    if (users.length <= 2) {
      return null;
    }

    // Для мастера в табе "Чаты сотрудников" показываем аватар мастера в общих чатах
    if (masterUser?.userId === userId && activeTab === EMasterTabs.SubAgentsChats) {
      return masterUser?.agentAvatarUrl ? (
        <Image src={masterUser.agentAvatarUrl} borderRadius="50%" objectFit="contain" />
      ) : (
        <Avatar size={22} type="agency" />
      );
    }

    // Для мастера в табе "Мои чаты" показываем аватар риелтора в общих чатах
    if (masterUser?.userId === userId && activeTab === EMasterTabs.MasterChats) {
      return opponent?.agentAvatarUrl ? (
        <Image src={opponent.agentAvatarUrl} borderRadius="50%" objectFit="contain" />
      ) : (
        <Avatar size={22} type="user" />
      );
    }

    // Для риелтора показываем аватар мастера в общих чатах
    if (opponent?.userId === userId) {
      return masterUser?.agentAvatarUrl ? (
        <Image src={masterUser.agentAvatarUrl} borderRadius="50%" objectFit="contain" />
      ) : (
        <Avatar size={22} type="agency" />
      );
    }

    return null;
  }, [
    activeTab,
    masterUser?.agentAvatarUrl,
    masterUser?.userId,
    opponent?.agentAvatarUrl,
    opponent?.userId,
    userId,
    users.length,
  ]);
};
